class infinityButton extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.btn[href]');
    this.onClickHandler = this.handler.bind(this);
    this.onScrollHandler = this.autoscrollhandler.bind(this);
    this.link && this.link.addEventListener('click', this.onClickHandler);
    if (this.classList.contains('autoscroll_yes')) {
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler, { passive: true });
      this.queueAutoscrollCheck();
      if (document.readyState === 'complete') {
        this.queueAutoscrollCheck(0);
      } else {
        window.addEventListener('load', () => this.queueAutoscrollCheck(0), { once: true });
      }
    }
  }

  handler(event) {
    event.preventDefault();
    if (this.destroyed || this.loading) return false;

    const link = event.currentTarget;
    if (!link || link.getAttribute('aria-disabled') === 'true') return false;

    const href = link.getAttribute('href');
    if (!href) return false;

    const shouldRestoreAutoscroll = this.classList.contains('autoscroll_yes');
    this.loading = true;
    link.classList.add('loading');
    const loader = document.querySelector('.collection_facets_loader');
    if (typeof placeCollectionLoader === 'function') placeCollectionLoader();
    if (loader) loader.classList.add('loading_now');

    fetch(this.getRelativeUrl(href), { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Infinity load failed: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        const currentContainer = document.querySelector('.collection__container');
        const nextContainer = parsed.querySelector('.collection__container');
        const currentButton = document.querySelector('infinity-button');
        const nextButton = parsed.querySelector('infinity-button');

        if (!currentContainer || !nextContainer) {
          throw new Error('Infinity load failed: collection container missing');
        }

        currentContainer.insertAdjacentHTML('beforeend', nextContainer.innerHTML);

        if (currentButton && nextButton) {
          currentButton.replaceWith(nextButton);
        } else if (currentButton) {
          currentButton.remove();
        }

        window.dispatchEvent(new Event('createProductView'));
      })
      .catch((error) => {
        console.error(error);
        if (shouldRestoreAutoscroll) link.classList.add('autoscroll');
      })
      .finally(() => {
        this.loading = false;
        link.classList.remove('loading');
        if (loader) loader.classList.remove('loading_now');
      });
  }

  autoscrollhandler() {
    if (!this.link || this.destroyed || this.loading) return false;
    if (!this.link.classList.contains('autoscroll')) return false;
    var rect = this.getBoundingClientRect ? this.getBoundingClientRect() : null;
    var contY = rect ? rect.top : parseInt(this.link.parentNode.offsetTop) - this.getWindowTopY();
    var wY = this.getWindowHeight() + 700;
    if (contY <= wY) {
      this.link.classList.remove('autoscroll');
      this.link.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
    }
  }

  queueAutoscrollCheck(delay) {
    const delays = typeof delay === 'number' ? [delay] : [80, 350, 1000];
    delays.forEach((wait) => {
      setTimeout(() => {
        if (!this.destroyed) this.autoscrollhandler();
      }, wait);
    });
  }

  getRelativeUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.href);
      return parsedUrl.pathname + parsedUrl.search;
    } catch (error) {
      return url;
    }
  }

  getWindowHeight() {
    return window.innerHeight;
  }

  getWindowTopY() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  disconnectedCallback() {
    this.destroyed = true;
    this.link && this.link.removeEventListener('click', this.onClickHandler);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onScrollHandler);
  }
}

if (!customElements.get('infinity-button')) {
  customElements.define('infinity-button', infinityButton);
}
